var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"product-video-button",on:{"click":_vm.clickHandler}},[_c('span',{staticClass:"product-video-button__icon"},[_c('the-svg-icon',{attrs:{"name":"play","size-w":40}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }